<plants-banner></plants-banner>
<plants-header></plants-header>
<loading-spinner [isWaitingForSearchResults]="isWaitingForSearchResults"></loading-spinner>
<main id="main-content">
  <div class="grid-row">
    <aside class="tablet:grid-col-2 sidebar">
      <sidebar-menu [isShowingSearchResults]="isShowingSearchResults"></sidebar-menu>
    </aside>
    <section
      class="tablet:grid-col-10 content"
      [class.content-page]="!isShowingSearchResults && !isPlantProfilePage"
      [class.padding-top-3]="isHomePage"
    >
      @if (!isHomePage) {
        <breadcrumbs></breadcrumbs>
      }
      <router-outlet></router-outlet>
    </section>
  </div>
</main>
<plants-footer></plants-footer>
